import { generateRegionSeo } from '../dynamic-seo-generator';
import { applyLocationSeo } from './seo-strategy.helpers';
import { SeoStrategyFn } from './seo-strategy.type';

/**
 * SEO strategy for region pages
 * Generates dynamic SEO from region data in cache
 */
export const RegionSeoStrategy: SeoStrategyFn = (seoContent, $document, cacheContent, regionId) => {
  applyLocationSeo(
    regionId,
    {
      seoKey: 'regionPage',
      pageName: 'region',
      pathPrefix: '/buy-plan/plans/region',
      locationFinder: (cache, id) => {
        const region = cache.cache.regions.find((r) => r._id === id);
        return region ? { name: region.name, data: region } : null;
      },
      seoGenerator: generateRegionSeo,
    },
    seoContent,
    $document,
    cacheContent
  );
};
